import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { closingLines } from '../data/offer';
export function ClosingSection() {
  return <section className="border-y border-primary/30 bg-surface py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-40" data-mp="12su1nsplz4ev">
      <div className="mx-auto max-w-4xl px-4" data-id="element-41" data-mp="xu0ok1e8hff8">
        <h2 id="closing-title" className="text-balance text-center font-display text-4xl font-bold uppercase leading-[1.02] tracking-tight text-foreground sm:text-5xl" data-id="element-42" data-mp="xs7gchnz2n54">
          Stop Struggling. <span className="text-accent" data-id="element-43" data-mp="17r5bi3fwlex3">Start Understanding.</span>
        </h2>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-44" data-mp="1ljl74j6h6anz">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center gap-3 rounded-xl border-l-4 border-primary bg-background px-4 py-3 text-sm font-semibold text-foreground" data-id="element-45" data-mp="1hhhu3q45qy0l" data-mpi={index}>
              <ChevronRightIcon className="h-4 w-4 shrink-0 text-primary" aria-hidden="true" data-id="element-46" data-mp="27da1m07elljx" />
              {line}
            </motion.li>)}
        </ul>
      </div>
    </section>;
}